import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { withNamespaces } from 'react-i18next';

import { useAppManager } from 'core/hooks';

import Header from 'apps/components/header/header';
import { MainWrapper } from 'legacyComponents/styled/lib';
import { CardSection } from 'legacyComponents/layout/cardSection';
import { ProjectCard } from 'legacyComponents/cards/types/project';

import { FeaturedProjectsManager } from 'apps/home/community/featured/appManager';

const CommunityFeatured = observer(() => {
  const appManager = useAppManager(FeaturedProjectsManager, null);
  const featuredConnection = appManager.featuredProjectsConn;
  const featuredProjects = featuredConnection.arrayApp;

  return (
    <>
      <Header />
      <MainWrapper>
        {featuredConnection.loadingMore || featuredProjects.length > 0 ? (
          <CardSection
            invisible={appManager.loading}
            title='Featured Projects'
            subTitle={' '}
            isOwnProfile={false}
            ownerName=''
            cardApp={featuredProjects}
            CardComponent={ProjectCard}
            noDataCardType='project'
            gridColumns={3}
            noSort
          />
        ) : null}
      </MainWrapper>
    </>
  );
});

CommunityFeatured.propTypes = {
  t: PropTypes.func,
};

export default withNamespaces()(CommunityFeatured);
